import { render, staticRenderFns } from "./TabSwiper.vue?vue&type=template&id=f6424a0e&scoped=true"
import script from "./TabSwiper.vue?vue&type=script&lang=js"
export * from "./TabSwiper.vue?vue&type=script&lang=js"
import style0 from "./TabSwiper.vue?vue&type=style&index=0&id=f6424a0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6424a0e",
  null
  
)

export default component.exports